import type React from 'react';
import { useState } from 'react';
import ProductModal from './ProductModal';
import type { CartItem } from '../../Store/CartItem/state';

interface ProductModalPresenterProps {
  children?: React.ReactNode;
  product: Pick<CartItem, 'editUrl' | 'name' | 'previewImage'>;
}

const ProductModalPresenter: React.FC<ProductModalPresenterProps> = ({
  children,
  product,
}) => {
  const [showProduct, setShowProduct] = useState<boolean>(false);

  const showProductModal = () => {
    setShowProduct(true);
  };

  const closeProductModal = () => {
    setShowProduct(false);
  };

  return (
    <>
      {showProduct && (
        <ProductModal
          product={product}
          onClose={closeProductModal}
        />
      )}
      <div
        data-testid="product-modal-presenter-wrapper"
        className="pointer"
        onClick={showProductModal}
      >
        {children}
      </div>
    </>
  );
};

export default ProductModalPresenter;
